export enum CART_ITEM_TYPES {
  MINT = "MINT",
  REDEEM = "REDEEM",
}
